import { ICamera } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllResellerCamera = async (status: string) => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/cameras`, {
        params: { status: status },
    });

    return { count: +data.count as number, rows: data.cameras as ICamera[] };
};
